export class AsignCurso {
    posutlantesId: string[];
    course: string;
}
